module.exports = __webpack_public_path__ + "img/granada.3807219a.jpg";